import { IWebInterfaceAction, WebInterfaceActionFactoryFromJS } from 'common/entities';
import { createSyncAction } from '@bimser/core';
import * as ActionTypes from './actionTypes';
import { FormsActionTypes, FormsEntities } from '@bimser/common';
import { List } from 'immutable';

export function appFormSaveClickedAction(data: IWebInterfaceAction) {
	const payload = WebInterfaceActionFactoryFromJS(data);
	return createSyncAction(ActionTypes.SAVE_BUTTON_CLICK, payload);
}

export function openChildFormOnNewPanelTransaction(data: IWebInterfaceAction) {
	const payload = WebInterfaceActionFactoryFromJS(data);
	return createSyncAction(ActionTypes.OPEN_CHILD_FORM_ON_NEW_PANEL, payload);
}

export function FormWillCloseAction(data: IWebInterfaceAction) {
	return createSyncAction(
		FormsActionTypes.FORM_WILL_CLOSE_ACTION,
		WebInterfaceActionFactoryFromJS(data)
	);
}

export function handleFormViewerDatas(data: IWebInterfaceAction) {
	return createSyncAction(
		ActionTypes.GET_FORMVIEWER_DATAS,
		WebInterfaceActionFactoryFromJS(data)
	);
}

export function fastApprove(data: IWebInterfaceAction) {
	return createSyncAction(
		ActionTypes.WORKFLOW_EVENT_CLICK,
		WebInterfaceActionFactoryFromJS(data)
	);
}

export function changePropertyAction(data: FormsEntities.IPropertyChangeTransaction) {
	let changeData: List<FormsEntities.PropertyChangeEventArgs> = List();
	data.data.forEach(property => {
		changeData = changeData.push(FormsEntities.PropertyChangeEventArgsFactoryFromJS(property));
	});
	const changeTransaction = FormsEntities.PropertyChangeTransactionFactory({
		data: changeData,
		transactionId: data.transactionId,
		windowId: data.windowId
	});
	return createSyncAction(
		FormsActionTypes.CHANGE_PROPERTY,
		FormsEntities.PropertyChangeActionFactory({
			data: changeTransaction,
			windowId: data.windowId
		})
	);
}
